exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comments-list-enter-active,.comments-list-leave-active,.comments-list-enter-active .comment__body{-webkit-transition:all .6s .3s;transition:all .6s .3s}.comments-list-move{-webkit-transition:-webkit-transform .6s;transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s, -webkit-transform .6s}.comments-list-enter,.comments-list-leave-to{opacity:0;-webkit-transform:translateY(-1.5rem);transform:translateY(-1.5rem)}.comments-list-enter .comment__body{background-color:#3c82c3}", ""]);

// exports
